import { Identifiable } from "./identifiable";
import { id } from "./id";
import {
  unavailabilityReason,
  UnavailabilityReason,
} from "./unavailabilityReason";
import { Resource, resource } from "./resource";
import { Planzone, planzone } from "./planzone";

type Unavailability = {
  label: string;
  reason: Identifiable<UnavailabilityReason>;
  resource: Identifiable<Resource>;
  planzone: Identifiable<Planzone>;
  startDate: string;
  endDate?: string;
  partialUnavailability: boolean;
  nonWorkedHoursCount: number;
};

const unavailability: Unavailability = {
  label: "",
  reason: { ...unavailabilityReason, uuid: id },
  resource: { ...resource, uuid: id },
  planzone: { ...planzone, uuid: id },
  startDate: "",
  partialUnavailability: false,
  nonWorkedHoursCount: 0,
};

export type { Unavailability };

export { unavailability };
